import { PartnerCertificatesTable } from './components/PartnerCertificatesTable';



export function PartnerCertificates(): JSX.Element {
  const itemsPerPage = 50;

  return (
    <>
      <PartnerCertificatesTable itemsPerPage={itemsPerPage} />
    </>
  );
}
